export default "__VITE_ASSET__Cdnw3UFc__"